import { Component } from '@angular/core';
import { AdminModule } from '../admin.module';

@Component({
  selector: 'app-billing-documents-page',
  standalone: true,
  imports: [AdminModule],
  templateUrl: './billing-documents-page.component.html',
  styleUrl: './billing-documents-page.component.css'
})
export class BillingDocumentsPageComponent {

}
